import toast from "react-hot-toast";
import axiosInstance from "./Axios";
import { clientRoutes } from "../routes";

export class PropertyApi {
  static hashtags = async () => {
    try {
      const res = await axiosInstance.get(`hashtags`, {
        params: {
          page: 1,
          limit: 30,
          created_at: "desc",
          search: "",
        },
      });
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getAgents = async (search: string = "") => {
    try {
      const res = await axiosInstance.get(`client/agents`, {
        params: {
          page: 1,
          limit: 100,
          created_at: "desc",
          search: search,
          agency_id: "",
        },
      });
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getProperties = async ({
    page = 1,
    limit = 30,
    search = "",
    listing_type_id = "",
    agents_id = "",
    property_stage_id = "",
    property_type_id = "",
    start_date = "",
    end_date = "",
    status = "",
  }: {
    page?: number;
    limit?: number;
    search?: string;
    listing_type_id?: string;
    agents_id?: string;
    property_stage_id?: string;
    property_type_id?: string;
    start_date?: string;
    end_date?: string;
    status?: string;
  }) => {
    try {
      const res = await axiosInstance.get(`properties`, {
        params: {
          page,
          limit: 15,
          created_at: "desc",
          search,
          property_stage_id,
          agent_id: agents_id,
          property_type_id,
          listing_type: listing_type_id,
          duration_start_date: start_date,
          duration_end_date: end_date,
          status,
        },
      });
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getSeperateProperties = async ({
    page,
    limit = 30,
    search,
    listing_type,
    agents_id,
    property_stage_id,
    property_type_id,
    start_date,
    end_date,
  }: {
    page: number;
    limit?: number;
    search: string;
    listing_type: string;
    agents_id: string;
    property_stage_id: string;
    property_type_id: string;
    start_date: string;
    end_date: string;
  }) => {
    try {
      const res = await axiosInstance.get(
        `properties/get-seperate-properties`,
        {
          params: {
            page,
            limit,
            created_at: "desc",
            search,
            property_stage_id,
            agent_id: agents_id,
            property_type_id,
            listing_type,
            duration_start_date: start_date,
            duration_end_date: end_date,
          },
        },
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static imagesUpload = async (data: any) => {
    try {
      const res = await axiosInstance.post(`properties/images/upload`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static deleteImage = async (image_id: string) => {
    try {
      const res = await axiosInstance.delete(`properties/images/${image_id}`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getSelectors = async () => {
    try {
      const res = await axiosInstance.get(`properties/selectors`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static createPropertie = async (data: any) => {
    try {
      const res = await axiosInstance.post(`properties`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static searchPropertyBank = async (search: string, country?: string) => {
    try {
      const res = await axiosInstance.get(`properties/search-bank`, {
        params: {
          search,
          country,
        },
      });
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static createPropertyPost = async (data: any) => {
    try {
      const res = await axiosInstance.post(`property-posts`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static createAnnouncementPost = async (data: any) => {
    try {
      const res = await axiosInstance.post(`announcement-posts`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static updateAnnouncementPost = async (
    data: any,
    announcement_post_id: string,
  ) => {
    try {
      const res = await axiosInstance.put(
        `announcement-posts/${announcement_post_id}`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static GetAnnouncementPosts = async (
    params: {
      page?: number;
      limit?: number;
      post_status?: string;
      announcement_type?: string;
      post_type?: string;
      start_date?: string;
      end_date?: string;
    } = {},
  ) => {
    try {
      const res = await axiosInstance.get(
        `announcement-posts/get-announcement-posts`,
        {
          params: {
            ...params,
          },
        },
      );

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static GetAnnouncementPostById = async (announcement_post_id: string) => {
    try {
      const res = await axiosInstance.get(
        `announcement-posts/get-announcement-posts/${announcement_post_id}`,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static createFestivalPost = async (data: any) => {
    try {
      const res = await axiosInstance.post(`festival-posts`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static updateFestivalPost = async (data: any, festival_post_id: string) => {
    try {
      const res = await axiosInstance.put(
        `festival-posts/${festival_post_id}`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static GetFestivalPosts = async (
    params: {
      page?: number;
      limit?: number;
      post_status?: string;
      festival_type?: string;
      post_type?: string;
      start_date?: string;
      end_date?: string;
    } = {},
  ) => {
    try {
      const res = await axiosInstance.get(`festival-posts/get-festival-posts`, {
        params: {
          ...params,
        },
      });

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static GetFestivalPostById = async (festival_post_id: string) => {
    try {
      const res = await axiosInstance.get(
        `festival-posts/get-festival-posts/${festival_post_id}`,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static createOnboardingPost = async (data: any) => {
    try {
      const res = await axiosInstance.post(`onboarding-posts`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static updateOnboardingPost = async (
    data: any,
    onboarding_post_id: string,
  ) => {
    try {
      const res = await axiosInstance.put(
        `onboarding-posts/${onboarding_post_id}`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static GetOnboardingPosts = async (
    params: {
      page?: number;
      limit?: number;
      post_status?: string;
      post_type?: string;
      start_date?: string;
      end_date?: string;
    } = {},
  ) => {
    try {
      const res = await axiosInstance.get(
        `onboarding-posts/get-onboarding-posts`,
        {
          params: {
            ...params,
          },
        },
      );

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static GetOnboardingPostById = async (onboarding_post_id: string) => {
    try {
      const res = await axiosInstance.get(
        `onboarding-posts/get-onboarding-posts/${onboarding_post_id}`,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static createAuction = async (data: any) => {
    try {
      const res = await axiosInstance.post(`property-auctions`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getAuctions = async (
    params: {
      start_date?: string;
      end_date?: string;
      status?: string;
      post_status?: string;
      property_id?: string;
    } = {},
  ) => {
    try {
      const res = await axiosInstance.get(`property-auctions/get-auctions`, {
        params: {
          ...params,
        },
      });

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static updateAuctionPost = async (data: any, auction_id: string) => {
    try {
      const res = await axiosInstance.put(
        `property-auctions/${auction_id}`,
        data,
      );

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getAuctionTimelinePosts = async (auction_id: string) => {
    try {
      const res = await axiosInstance.get(
        `property-auctions/${auction_id}/timeline-posts`,
      );

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static updatePropertyPost = async (property_post_id: string, data: any) => {
    try {
      const res = await axiosInstance.put(
        `property-posts/${property_post_id}`,
        data,
      );
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static updatePropertyPostMultipart = async (
  property_post_id: string,
  formData: FormData,
) => {
  try {
    const res = await axiosInstance.put(
      `property-posts/${property_post_id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return { data: res.data };
  } catch (err: any) {
    return {
      error: "Something went wrong !",
      data: err?.response?.data,
    };
  }
};

  static getPropertyPosts = async (
    params: {
      start_date?: string;
      end_date?: string;
      status?: string;
      property_id?: string;
      agent_ref?: string;
      agency_ref?: string;
      page?: number;
      limit?: number;
      search?: string;
      created_at?: "asc" | "desc";
      subscription_type?: string | string[];
    } = {},
  ) => {
    try {
      const res = await axiosInstance.get(`property-posts/get-property-posts`, {
        params: {
          ...params,
        },
      });

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static GetScheduleOpenHome = async (
    params: {
      start_date?: string;
      end_date?: string;
      post_status?: string;
      property_ids?: string;
      post_type?: string;
    } = {},
  ) => {
    try {
      const res = await axiosInstance.get(
        `open-home-schedules/get-open-home-schedules`,
        {
          params: {
            ...params,
          },
        },
      );

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static GetAgencyScheduleOpenHome = async (
    params: {
      start_date?: string;
      end_date?: string;
      post_status?: string;
      agency_id?: string;
      post_type?: string;
      page?: number;
      limit?: number;
    } = {},
  ) => {
    try {
      const res = await axiosInstance.get(
        `agency-open-home-schedules/get-agency-open-home-schedules`,
        {
          params: {
            ...params,
          },
        },
      );

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static createOpenHomeSchedule = async (data: any) => {
    try {
      const res = await axiosInstance.post(`open-home-schedules`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getPropertieById = async (property_id: string) => {
    try {
      const res = await axiosInstance.get(`properties/${property_id}`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getOpenHomeScheduleById = async (schedule_id: string) => {
    try {
      const res = await axiosInstance.get(
        `open-home-schedules/get-open-home-schedules/${schedule_id}`,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getAgencyOpenHomeScheduleById = async (schedule_id: string) => {
    try {
      const res = await axiosInstance.get(
        `agency-open-home-schedules/${schedule_id}`,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getAuctionScheduleById = async (auction_id: string) => {
    try {
      const res = await axiosInstance.get(
        `property-auctions/get-auctions/${auction_id}`,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getTimelinePostById = async (postId: string) => {
    try {
      const res = await axiosInstance.get(
        `property-auctions/timeline-post/${postId}`,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static updateOpenHomePost = async (
    open_home_schedule_id: string,
    data: any,
  ) => {
    try {
      const res = await axiosInstance.put(
        `open-home-schedules/${open_home_schedule_id}`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

   static updateOpenHomePostMultipart = async (
    open_home_schedule_id: string,
   formData: FormData,
  ) => {
    try {
      const res = await axiosInstance.put(
        `open-home-schedules/${open_home_schedule_id}`,
        formData,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static updateOpenHomeScheduleForAgency = async (
    agency_open_home_schedule_id: string,
    data: any,
  ) => {
    try {
      const res = await axiosInstance.put(
        `agency-open-home-schedules/${agency_open_home_schedule_id}`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getPropertyPostById = async (propertyPostId: string) => {
    try {
      const res = await axiosInstance.get(
        `property-posts/get-property-posts/${propertyPostId}`,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getPropertyPostTimeline = async (
    propertyPostId: string,
    params: { page?: number; limit?: number; created_at?: "asc" | "desc" } = {},
  ) => {
    try {
      const res = await axiosInstance.get(
        `property-posts/get-property-posts/${propertyPostId}/timeline`,
        { params: { page: 1, limit: 20, created_at: "desc", ...params } },
      );
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getPropertieStages = async (listing_type?: string) => {
    try {
      // Normalize listing type to match backend expectations
      const normalizeType = (type?: string): string => {
        const map: Record<string, string> = {
          lease: "rent",
          "for lease (commercial)": "rent",
          sale: "sell",
          "for sale (residential)": "sell",
          "for sale (commercial)": "sell",
        };
        return map[type?.toLowerCase() || ""] || type || "";
      };

      const normalizedListingType = normalizeType(listing_type);

      const res = await axiosInstance.get(`property-stages`, {
        params: {
          page: 1,
          limit: 100,
          created_at: "desc",
          search: "",
          listing_type: normalizedListingType,
        },
      });

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static regeneratePropertyDesigns = async (payload: {
    agency_id: string;
    agent_id: string;
    listing_type: string;
    property_id: string;
  }) => {
    try {
      const res = await axiosInstance.post(
        `properties/regenerate-property-designs`,
        payload,
      );
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getAllStagesWithTitles = async (listing_type: "rent" | "sell") => {
    try {
      const res = await axiosInstance.get(
        `property-stages/get-all-with-titles`,
        {
          params: {
            listing_type,
          },
        },
      );

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getSavedStageConfigs = async (agencyId: string) => {
    try {
      const res = await axiosInstance.get(
        `property-stages/get-agency-stage-configs/${agencyId}`,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static updateStageConfigs = async (
    configs: {
      stage_id: string;
      display_title_id: string;
      agency_id?: string;
    }[],
  ) => {
    try {
      const res = await axiosInstance.put(`property-stages/configs`, {
        configs,
      });

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static updatePropertie = async (data: any, property_id: string) => {
    try {
      const res = await axiosInstance.put(`properties/${property_id}`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static deleteProperty = async (property_id: string) => {
    try {
      const res = await axiosInstance.delete(`properties/trash/${property_id}`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static deletePropertyPermanent = async (property_id: string) => {
    try {
      const res = await axiosInstance.delete(
        `properties/delete-permanent/${property_id}`,
      );

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static deleteOpenHomeProperty = async (open_home_property_id: string) => {
    try {
      const res = await axiosInstance.delete(
        `/open-home-schedules/open-home-properties/${open_home_property_id}`,
      );
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static createPropertyJourney = async (data: { property_id: string }) => {
    try {
      const res = await axiosInstance.post(
        `property-posts/create-property-journey`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Failed to initialize property journey",
        data: err?.response?.data,
      };
    }
  };

  static updatePropertyJourney = async (payload: {
    property_id: string;
    design_stage: string;
    is_skipped: boolean;
  }) => {
    try {
      const res = await axiosInstance.patch(
        `property-posts/update-property-journey`,
        payload,
      );
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to update journey progress",
        data: err?.response?.data,
      };
    }
  };

  static createPostByStage = async (payload: {
    property_id: string;
    design_stage: string;
    listing_type?: string;
    template_type?: string;
    subscription_type?: string;
  }) => {
    try {
      const res = await axiosInstance.post(
        `property-posts/create-post-by-stage`,
        payload,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Failed to create post record for this stage",
        data: err?.response?.data,
      };
    }
  };

  static getJourneyView = async (propertyId: string, listingType: string) => {
    try {
      const res = await axiosInstance.get(`property-posts/get-journey-view`, {
        params: {
          property_id: propertyId,
          listing_type: listingType,
        },
      });
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to fetch journey view",
        data: err?.response?.data,
      };
    }
  };

  static updateJourneyProgress = async (payload: {
    property_id: string;
    design_stage: string;
    is_skipped: boolean;
  }) => {
    try {
      const res = await axiosInstance.patch(
        `property-posts/update-journey-progress`,
        payload,
      );
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to update journey progress",
        data: err?.response?.data,
      };
    }
  };
}
